import { SegmentControlsFilterValueOperators } from 'features/segment-controls/constants/segment-controls-filter-value-operators';
import { SegmentFilter } from '../segment-controls.types';
import { v4 as guid } from 'uuid';

export const createSegmentFilter = (
  segmentId: string,
  order: number,
  value: string,
  operator: SegmentControlsFilterValueOperators
): SegmentFilter => {
  return {
    id: guid(),
    order,
    segmentId,
    values: [{ value, valueOperator: operator }]
  };
};
